import React from 'react';
import styles from "@/page-components/detail/Banner/styles.module.less";

type TPcBanner = {
  title?: string;
  english_title?: string;
  intro?: string;
}
const PCBanner:React.FC<TPcBanner> = ({title,english_title,intro}) => {
  return (
    <div className={styles.pc_banner_wrapper}>
      <div>
        <h3 className={styles.title}>{title}</h3>
        <h3 className={styles.english_title}>{english_title}</h3>
        <h3 className={styles.subtitle}>{intro}</h3>
      </div>
    </div>
  )
}
export default PCBanner;
